export const Scope3ReportingConstants = {
    GET_ALL_SCOPE3_REPORTING_SUCCESS: "GET_ALL_SCOPE3_REPORTING_SUCCESS",
    GET_ALL_SCOPE3_REPORTING_ERROR: "GET_ALL_SCOPE3_REPORTING_ERROR",
    ALL_SCOPE3_REPORTING_LOADING: "ALL_SCOPE3_REPORTING_LOADING",
};
